import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
} from '@mui/material';
import { TaskImage } from '../../../../../services/openapi/models/TaskImage';

interface ImagePreviewModalProps {
  open: boolean;
  onClose: () => void;
  selectedImage: TaskImage | null;
}

export default function ImagePreviewModal({
  open,
  onClose,
  selectedImage,
}: ImagePreviewModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='lg'
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          borderRadius: 'var(--border-radius-lg)',
        },
      }}>
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
        Bildvorschau
        <Button onClick={onClose} sx={{color: 'white'}}>
          ✕
        </Button>
      </DialogTitle>
      <DialogContent sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', p: 2, backgroundColor: '#fff'}}>
        {selectedImage && (
          <img
            src={`${
              import.meta.env.DEV
                ? 'http://localhost:8008'
                : import.meta.env.VITE_BACKEND_URL || ''
            }${selectedImage.image_path}`}
            alt='Task Image'
            style={{
              maxWidth: '100%',
              maxHeight: '70vh',
              objectFit: 'contain',
              borderColor: '#2196f3',
              borderWidth: '2px',
              borderStyle: 'dashed'
            }}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
